import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimInput]'
})
export class TrimInputDirective {

  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() private control: NgControl // es opcional para soportar template + reactive forms
  ) { }

  // Recortar al perder el foco
  @HostListener('blur')
  onBlur(): void {
    this.trim();
  }

  // Si pegan texto, recorta después del paste
  @HostListener('paste', ['$event'])
  onPaste(_: ClipboardEvent): void {
    // esperar al paste real
    setTimeout(() => this.trim(), 0);
  }

  @HostListener('change')
  onChange(): void {
    this.trim();
  }
  // @HostListener('input')
  // onInput(): void {
  //   this.trim();
  // }
  private trim(): void {
    const inputEl = this.el.nativeElement;
    const value = inputEl.value;
    if (typeof value !== 'string') return;

    const trimmed = value.trim();
    if (trimmed === value) return; // no cambios

    // 1) Actualiza el DOM del input
    inputEl.value = trimmed;

    // 2) Si hay FormControl, actualiza su valor
    if (this.control && this.control.control) {
      // setValue sin emitir eventos para evitar bucles; luego forzamos validación
      this.control.control.setValue(trimmed, { emitEvent: false });
      this.control.control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }

    // 3) Disparar evento 'input' para que matInput / ngModel recoja el cambio visualmente
    const ev = new Event('input', { bubbles: true });
    inputEl.dispatchEvent(ev);
  }
}
